import { IResourceComponentsProps } from "@pankod/refine-core";

import { Create, Form, Input, Radio, useForm } from "@pankod/refine-antd";

import { ICategory } from "interfaces";

export const CategoryCreate: React.FC<IResourceComponentsProps> = () => {
    const { formProps, saveButtonProps } = useForm<ICategory>();

    return (
        <Create saveButtonProps={saveButtonProps}>
            <Form {...formProps} layout="vertical">
                <Form.Item label="Locale" name="locale">
                    <Radio.Group>
                        <Radio.Button value="en">English</Radio.Button>
                        <Radio.Button value="zh-Hans">中文</Radio.Button>
                    </Radio.Group>
                </Form.Item>
                <Form.Item
                    label="Title"
                    name="title"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
            </Form>
        </Create>
    );
};
